<form class="chat">
    <div class="history" #messageContainer>
        <div class="message" *ngFor="let mssg of messages; let last = last">
            <div class="icon">
                <mat-icon *ngIf="mssg.role !== 'assistant'">account_circle</mat-icon>
                <svg-icon
                    *ngIf="mssg.role === 'assistant'"
                    class="icon"
                    src="assets/svg/core-dark.svg"
                    [svgStyle]="{
                    'width.px': '24',
                    'height.px': '24'
                    }"
                ></svg-icon>
            </div>
            <div>{{mssg.content}}</div>
            {{last ? scrollToBottom() : ''}}
        </div>
    </div>
    <lhpe-textarea
        controlName="newMessage"
        [formGroup]="chatForm"
        placeholder="Enter your message here"
        [required]="true"
        [rows]="3"
        >
    </lhpe-textarea>
    <div class="buttons">
        <!--<button mat-button color="accent" class="flat-button" [disabled]="!canPreview" (click)="preview()">Preview</button>-->
        <button mat-button color="lightGreen" class="flat-button" [disabled]="!chatForm.valid || loading" (click)="sendMessage()">Send</button>
    </div>
    <div class="loading" *ngIf="loading">
        <mat-spinner diameter="20"></mat-spinner>
        Please wait...
    </div>
</form>